import { render, staticRenderFns } from "./color-picker-dialog.vue?vue&type=template&id=4f5e6156&"
import script from "./color-picker-dialog.vue?vue&type=script&lang=js&"
export * from "./color-picker-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports